import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { withRouter } from "react-router";
import { Modal, Input, Spin, Checkbox } from "antd";

import { saveDraft, emailSummary } from "actions/emailActions";
import { ACTION_TYPE } from "reducers/actionType";
import { collectUserInput } from "utils/helpers";

import "styles/EmailModal.scss";
import MasterButton, { BUTTON_TYPES } from "components/ui/MasterButton";
import CustomRadioGroup from "components/personality/CustomRadioGroup";
import { getInput } from "actions/inputActions";

const EMAIL_FORMAT =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

class EmailModal extends Component {
  // ---------------------- Modal Functions ----------------------- //
  constructor(props) {
    super(props);
    const { email: prevEmail } = props;
    this.state = {
      email: prevEmail,
      showError: false,
      confirmed: false,
      consent: true,
      role: null,
    };
  }
  handleCheckConsent = (e) => {
    const { checked } = e.target;
    this.setState({ consent: checked });
  };

  reset = () => {
    const { email } = this.state;
    const { dispatch, email: prevEmail } = this.props;
    this.setState({
      email: email ? email : prevEmail,
      showError: false,
      confirmed: false,
      consent: true,
      role: null,
    });
    // clear errors from eligibility and recommendations
    dispatch({
      type: ACTION_TYPE.eligibilityFetch.success,
      data: { error: null },
    });
    dispatch({
      type: ACTION_TYPE.recommendationsFetch.success,
      data: { error: null },
    });
  };

  handleChangeRole = (_, val) => {
    this.setState({ role: val });
  };

  handleChange = (e) => this.setState({ email: e.target.value });
  // handleAfterClose = () => this.setState({ confirmed: false });
  handleContinue = () => this.props.closeModal();
  componentDidMount = () => this.reset();

  // ------------------------------------------------------------ //

  validateEmail = () => {
    const { email: newEmail } = this.state;
    const { email: prevEmail, dispatch } = this.props;
    const newEmailExists = newEmail && newEmail.length > 0;
    const prevEmailExists = prevEmail && prevEmail.length > 0;
    // no prev input, no new input
    if (!newEmailExists && !prevEmailExists) return false;
    if (!newEmailExists) {
      return prevEmail;
    } else {
      const emailMatch = !newEmail ? false : newEmail.match(EMAIL_FORMAT);
      if (!emailMatch) {
        this.setState({ showError: true });
        return false;
      } else {
        dispatch({
          type: ACTION_TYPE.email,
          data: { email: newEmail },
        });
        this.setState({ showError: false });
        return newEmail;
      }
    }
  };

  handleSaveDraft = () => {
    const { consent, role } = this.state;
    const validEmail = this.validateEmail();
    if (validEmail) {
      this.setState({ confirmed: true });
      const { recommendations_input_hash } = this.props;
      const userInput = collectUserInput();
      this.props.dispatch(
        saveDraft(
          userInput,
          validEmail,
          recommendations_input_hash,
          consent,
          role
        )
      );
    } else {
      this.setState({ confirmed: false });
    }
  };

  handleEmailSummary = () => {
    const { consent, role } = this.state;
    const validEmail = this.validateEmail();
    if (validEmail) {
      this.setState({ confirmed: true });
      const { recommendations_input_hash, eligibility_input_hash } = this.props;
      this.props.dispatch(
        emailSummary(
          validEmail,
          recommendations_input_hash,
          eligibility_input_hash,
          consent,
          role
        )
      );
    } else {
      this.setState({ confirmed: false });
    }
  };

  startOver = async () => {
    const { dispatch } = this.props;
    dispatch(getInput());
    dispatch({
      type: ACTION_TYPE.INTEREST.RESET,
    });
    dispatch({
      type: ACTION_TYPE.SKILL.RESET,
    });
    dispatch({
      type: ACTION_TYPE.PERSONALITY.RESET,
    });

    dispatch({
      type: ACTION_TYPE.CAREER.RESET,
    });
    dispatch({
      type: ACTION_TYPE.COURSE.RESET,
    });

    dispatch({
      type: ACTION_TYPE.recommendationsFetch.success,
      data: { recommendations: [] },
    });
    dispatch({
      type: ACTION_TYPE.pickRecSubs,
      data: { userRecSubs: [] },
    });

    dispatch({
      type: ACTION_TYPE.pickOthSubs,
      data: { userOthSubs: [] },
    });

    dispatch({
      type: ACTION_TYPE.pickAddSubs,
      data: { userAddSubs: [] },
    });

    dispatch({
      type: ACTION_TYPE.additionalSubjects,
      data: { additionalSubjects: [] },
    });

    dispatch({
      type: ACTION_TYPE.eligibilityFetch.success,
      data: { eligibility: "" },
    });
  };

  // ---------------------- Render Screen Functions ----------------------- //

  renderInput = () => {
    const { showError, email } = this.state;
    return (
      <>
        <label className="label">Email</label>
        <Input
          value={email}
          aria-label="Enter email"
          placeholder={email ? email : "email@email.com"}
          onPressEnter={this.handleEnter}
          onChange={this.handleChange}
          disabled={this.state.confirmed}
          className={showError ? "input-red-underline" : "input-grey-underline"}
          style={{ marginBottom: 18 }}
        />
        {showError && (
          <p className="error-message">
            Address is not valid, please try again
          </p>
        )}
      </>
    );
  };

  renderEntryScreen = () => {
    const { consent, role, email } = this.state;
    const { summary } = this.props;
    return (
      <div>
        {summary ? (
          <h1 className="title">
            Enter your email and we'll send you your subject summary
          </h1>
        ) : (
          <div>
            <h1 className="title">Save and continue later</h1>
            <p>
              Enter your email and we’ll send you a link to your progress so far
            </p>
          </div>
        )}
        {this.renderInput()}

        <CustomRadioGroup
          value={role}
          heading="I am a"
          choices={["student", "parent", "year adviser", "other"]}
          onClickRadio={this.handleChangeRole}
        />
        <MasterButton
          wide={true}
          type={BUTTON_TYPES.PRIMARY}
          text={summary ? "Email My Summary" : "Email My Choices"}
          callback={summary ? this.handleEmailSummary : this.handleSaveDraft}
          style={{ marginBottom: 18 }}
          disabled={!role || !email}
        />
        <Checkbox checked={consent} onChange={this.handleCheckConsent}>
          I consent to receive marketing emails
        </Checkbox>
        <p className="disclaimer">
          We will keep your details secure: read our
          <a
            href="https://www.uac.edu.au/about/privacy-legal"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            privacy policy.
          </a>
        </p>
      </div>
    );
  };

  // Render loading if we are awaiting response
  renderConfirmScreen = () => {
    const { summary } = this.props;

    let loading = false;
    if (summary) {
      loading = this.props.emailSummary.loading;
    } else {
      loading = this.props.saveDraft.loading;
    }

    if (loading) {
      return (
        <div>
          <h1 className="title">
            {" "}
            <Spin className="margin-right" /> Sending request
          </h1>
          {this.renderInput()}
        </div>
      );
    }

    // not loading, confirmed
    return (
      <>
        <h1 className="title">
          {summary ? (
            <div>
              <h1 className="title"> Summary has been sent </h1>
              {this.renderInput()}
              <div className="center-container">
                <NavLink to="/summary">
                  <MasterButton
                    type={BUTTON_TYPES.SECONDARY}
                    wide={true}
                    text="Return to Subject Summary"
                    style={{ marginBottom: 20 }}
                  />
                </NavLink>
                <p className="title">
                  or{" "}
                  <NavLink
                    to="/"
                    className="underline title"
                    onClick={this.startOver}
                  >
                    start over
                  </NavLink>
                </p>
              </div>
            </div>
          ) : (
            <div>
              <h1 className="title">Choices saved and email sent</h1>
              {this.renderInput()}
              <MasterButton
                type={BUTTON_TYPES.SECONDARY}
                wide={true}
                text="Continue"
                callback={this.handleContinue}
              />
            </div>
          )}
        </h1>
      </>
    );
  };

  renderErrorScreen = (error) => {
    const { errorType, errors } = error;
    return (
      <div>
        <h1 className="title"> Your email could not be sent. </h1>
        <p className="title">{errorType}</p>
        {errors && errors.map((err, i) => <p key={i}>{err}</p>)}
        <MasterButton
          type={BUTTON_TYPES.SECONDARY}
          wide={true}
          callback={this.reset}
          text="reset"
        />
      </div>
    );
  };

  renderScreens = () => {
    const { confirmed } = this.state;
    const { summary, emailSummary, saveDraft } = this.props; // whether we are on the atar subject summary or not.
    const error = summary ? emailSummary.error : saveDraft.error;

    if (error && confirmed) {
      // error when email sent
      return this.renderErrorScreen(error);
    } else if (confirmed) {
      // no error, sent successfully
      return this.renderConfirmScreen();
    } else {
      // receiving user input
      return this.renderEntryScreen();
    }
  };

  render() {
    return (
      <Modal
        open={this.props.modalVisible}
        onCancel={this.props.closeModal}
        footer={null}
        afterClose={this.reset}
      >
        {this.renderScreens()}
      </Modal>
    );
  }
}

const mapStateToProps = (store) => {
  // general
  const { input } = store.inputReducer;
  const { email } = store.emailReducer;
  const saveDraft = store.saveDraftReducer;
  const emailSummary = store.emailSummaryReducer;
  const { eligibility } = store.eligibilityReducer;
  const { recommendations_input_hash, eligibility_input_hash } =
    store.hashReducer;

  return {
    email,
    input,
    eligibility,
    recommendations_input_hash,
    eligibility_input_hash,
    saveDraft, // hash, loading, error
    emailSummary, // hash rec, hash elig, loading, error
  };
};

export default withRouter(connect(mapStateToProps)(EmailModal));
